import {Injectable} from '@angular/core';
import {User, Tokens} from '../models/auth.model';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import * as jwt_decode from "jwt-decode";
import {CookieService} from "./cookie.service";
import {AuthApiService} from "../api/auth.api";

@Injectable({providedIn: 'root'})
export class AuthenticationService {
  private user: User;
  private tokens: Tokens;
  private decodedToken: any;

  constructor(
    private cookieService: CookieService,
    private authApi: AuthApiService
  ) {
  }

  getTokens() {
    if (!this.tokens) {

      const tokens = JSON.parse(localStorage.getItem('tokens'))
      this.tokens = tokens;

      if(tokens) {
        this.decodedToken = this.decodeToken(tokens.accessToken)
      }
    }
    return this.tokens
  }

  setTokens(tokens: Tokens) {
    this.tokens = tokens;
    // store user details and jwt in cookie
    localStorage.setItem('tokens', JSON.stringify(tokens));

    // Save decode token
    this.decodedToken = this.decodeToken(tokens.accessToken)

    //let userPrefsJson = JSON.stringify(this.getDecodedToken(tokens.moreInfoToken).token.moreInformation.mensaje);
    //this.cookieService.setCookie('user_prefs', userPrefsJson ,null);
  }

  storeMoreInfoTokenData(moreInfoToken: string) {
    // store user details jwt into localstorage
    if(moreInfoToken) {
      let userPrefsJson = this.decodeToken(moreInfoToken).token.moreInformation.mensaje;
      localStorage.setItem('user_prefs', userPrefsJson);
    }
  }

  /**
   * Logout the user
   */
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('tokens');
    this.user = null;
    this.tokens = null;
  }

  refreshToken(refreshToken: string): Observable<any> {
    return this.authApi.refreshToken(refreshToken).pipe(tap((data) => {
      this.replaceAccessToken(data.newAccessToken)
    }));
  }

  replaceAccessToken(token: string) {
    const newTokens = {
      ...this.tokens,
      accessToken: token
    }

    this.setTokens(newTokens)
  }

  private decodeToken(token: string): any {
    try{
      return jwt_decode(token);
    }
    catch(Error){
      return null;
    }
  }

  public obtainDecodedAuthToken(): any {
    return this.decodedToken
  }

  public getLoggedUserRoleId(): any {
    let authToken = this.obtainDecodedAuthToken();
    return authToken.token.user.idRole;
  }
  public getLoggedUserId(): any {
    let authToken = this.obtainDecodedAuthToken();
    return authToken.token.user.data.id;
  }
}
